import store from "@/portal/store";
import initShopCartDom from "@/portal/modules/shopCartDom";
import initLocationModal from "@/portal/modules/locationModal";
import {initHint} from "@/base/hints";

/**
 * Инициализация страниц витрины без Vue.
 */
export default function initStorefrontPortal() {
    if (!window.appConfig) {
        console.warn('appConfig не определён, портал не инициализирован');
        return;
    }

    store.dispatch('load_user', window.appConfig.user);
    store.dispatch('initShopCart', window.appConfig.shopCart);

    initShopCartDom(store);
    initLocationModal();
    initHint('select-current-np', {store}).then(r => {});
    initScrollToHash();
}

function initScrollToHash() {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
        scrollToElement(hash);
    }

    window.addEventListener('hashchange', () => {
        const nextHash = window.location.hash.replace('#', '');
        if (nextHash) {
            scrollToElement(nextHash);
        }
    });
}

function scrollToElement(elementId) {
    const target = document.getElementById(elementId);
    if (!target) {
        return;
    }
    target.scrollIntoView({behavior: 'smooth'});
}
